export function setLocalBank(name, value) {
  localStorage.setItem(name, value);
}

export function getLocalBank(name) {
  return localStorage.getItem(name);
}

export function removeLocalBank(name) {
  return localStorage.removeItem(name);
}

